import { Capacitor } from "@capacitor/core";
import { Platform } from "@src/mobile/utils/platform";

/**
 * Shows the native in-app review sheet (App Store / Play Store). No-op on web,
 * and on native binaries that don't include the plugin.
 *
 * Multi-version OTA: one bundle reaches several native versions, and this
 * plugin was added after some still-supported binaries shipped. Gate on
 * plugin availability so older binaries get a clean no-op instead of an
 * `Unimplemented` rejection (see README — "absent plugin → isPluginAvailable").
 *
 * Stores throttle review-prompt frequency per app install, so multiple
 * calls in quick succession may not surface the sheet.
 */
export async function requestInAppReview(): Promise<void> {
  if (!Platform.isMobile || !Capacitor.isPluginAvailable("InAppReview")) {
    return;
  }

  const { InAppReview } = await import("@capacitor-community/in-app-review");
  await InAppReview.requestReview();
}
